import React, {useEffect} from 'react';
import useUserStore from '../../common/stores/user';

/**
 * @return {null}
 * @constructor
 */
const Logout: React.FC = () => {
	const {logout} = useUserStore();

	useEffect(() => {
		logout();
	}, [logout]);

	return <></>;
}

export default Logout;
